export function objectIsEmpty(obj: object): boolean {
  if (!isObject(obj)) { throw new Error(`${obj} is not an object`); }
  return Object.entries(obj).length === 0 && obj.constructor === Object;
}

export function isObject(obj: object): boolean {
  return typeof obj === 'object' && obj !== null;
}
